import { api } from './client';

// Block 7.6 (2026-05-27): Commissioner UX detection + rescue API.

export type FopIncomeExclusionReason =
  | 'NONE'
  | 'RETURNABLE_FINANCIAL_AID'
  | 'PERSONAL_FUNDS'
  | 'NON_BUSINESS_INCOME'
  | 'BANK_FX_DIFFERENCE'
  | 'REFUND_TO_CUSTOMER'
  | 'TRANSIT_FUNDS'
  | 'COMMISSIONER_TRANSIT';

export const FOP_EXCLUSION_REASON_LABELS: Record<FopIncomeExclusionReason, string> = {
  NONE: 'Включити у дохід єдинника (default)',
  RETURNABLE_FINANCIAL_AID: 'Поворотна фін. допомога',
  PERSONAL_FUNDS: 'Власні кошти ФОП',
  NON_BUSINESS_INCOME: 'Громадянський дохід',
  BANK_FX_DIFFERENCE: 'Курсова різниця банку',
  REFUND_TO_CUSTOMER: 'Повернення покупцю',
  TRANSIT_FUNDS: 'Транзитні суми',
  COMMISSIONER_TRANSIT: 'Комітентські кошти',
};

export interface CommissionerWarningCheck {
  is_commissioner_relationship: boolean;
  contract_id: string | null;
  contract_number: string | null;
  contract_direction: string | null;
  counterparty_id: string;
  counterparty_name: string;
  warning_message: string | null;
  recommended_action: string | null;
}

export interface AccEntryFopExclusionPatchBody {
  fop_income_exclusion_reason: FopIncomeExclusionReason;
  comment?: string | null;
}

export interface AccEntryFopExclusionPatchResult {
  entry_id: string;
  old_reason: FopIncomeExclusionReason;
  new_reason: FopIncomeExclusionReason;
  content: string | null;
}

export interface AccEntryRescueRow {
  id: string;
  line_number: number;
  dt_account_code: string;
  cr_account_code: string;
  amount: string;
  content: string | null;
  fop_income_exclusion_reason: FopIncomeExclusionReason;
}

export const commissionerWarning = {
  check: (organization_id: string, counterparty_id: string) =>
    api
      .get<CommissionerWarningCheck>('/services/commissioner-warning-check', {
        params: { organization_id, counterparty_id },
      })
      .then((r) => r.data),
  listEntriesForDocument: (organization_id: string, document_id: string) =>
    api
      .get<AccEntryRescueRow[]>('/acc-entries', {
        params: { organization_id, document_id },
      })
      .then((r) => r.data),
  patchFopExclusionReason: (entry_id: string, body: AccEntryFopExclusionPatchBody) =>
    api
      .patch<AccEntryFopExclusionPatchResult>(
        `/acc-entries/${entry_id}/fop-exclusion-reason`,
        body,
      )
      .then((r) => r.data),
};
